const TRANSLATED_FIELDS = ["name", "description", "more_info"];

function readLocalizedValue(entry) {
  if (typeof entry === "string") return entry;
  return String(entry?.value ?? "");
}

function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function renderInlineMarkdown(value) {
  return escapeHtml(value)
    .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/gi, '<a href="$2">$1</a>')
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>")
    .replace(/`([^`]+)`/g, "<code>$1</code>");
}

export function markdownToRichText(value) {
  const source = String(value || "").replace(/\r\n?/g, "\n");
  if (!source) return "";
  const lines = source.split("\n").map((line) => {
    if (!line) return '<p class="route-translation-line"><br></p>';
    const heading = line.match(/^(#{1,6})\s+(.*)$/);
    if (heading) {
      return `<p class="route-translation-line"><strong>${renderInlineMarkdown(heading[2])}</strong></p>`;
    }
    const listItem = line.match(/^\s*([-*]|\d+\.)\s+(.*)$/);
    if (listItem) {
      const prefix = /\d+\./.test(listItem[1]) ? `${listItem[1]} ` : "• ";
      return `<p class="route-translation-line">${prefix}${renderInlineMarkdown(listItem[2])}</p>`;
    }
    if (/^>\s?/.test(line)) {
      return `<p class="route-translation-line">&gt; ${renderInlineMarkdown(line.replace(/^>\s?/, ""))}</p>`;
    }
    return `<p class="route-translation-line">${renderInlineMarkdown(line)}</p>`;
  });
  return lines.join("");
}

export function buildRoutePointTranslationData(points) {
  return points.map((point) => ({
    id: String(point?.id || ""),
    name: readLocalizedValue(point?.name?.en),
    description: readLocalizedValue(point?.description?.en),
    more_info: readLocalizedValue(point?.more_info?.en),
  }));
}

export function prepareTranslatedPointUpdates(points, translatedRows, language) {
  const sourceById = new Map(points.map((point) => [String(point?.id || ""), point]));
  if (!Array.isArray(translatedRows) || translatedRows.length !== points.length) {
    throw new Error("The translation response has a different number of points.");
  }
  const seen = new Set();
  return translatedRows.map((row) => {
    const id = String(row?.id || "");
    const point = sourceById.get(id);
    if (!point || seen.has(id)) {
      throw new Error("The translation response contains an unknown or repeated point ID.");
    }
    if (TRANSLATED_FIELDS.some((field) => typeof row?.[field] !== "string")) {
      throw new Error(`The translation for point ${id} is incomplete.`);
    }
    seen.add(id);
    const localized = {};
    TRANSLATED_FIELDS.forEach((field) => {
      const currentField = point?.[field] || {};
      const currentEntry = currentField[language];
      const value =
        field === "name" || /<\/?[a-z][^>]*>/i.test(row[field])
          ? row[field]
          : markdownToRichText(row[field]);
      localized[field] = {
        ...currentField,
        [language]:
          currentEntry && typeof currentEntry === "object"
            ? { ...currentEntry, value }
            : value,
      };
    });
    return { id, localized };
  });
}
